import { Component } from '@angular/core';
import { FieldWrapper } from '@ngx-formly/core';

@Component({
  standalone: false,
    selector: 'field-set',
    templateUrl: './field-set.component.html',
})
export class FieldSetWrapperComponent extends FieldWrapper {
}
